import { useState, useEffect, memo } from 'react';
import { Input, Select } from 'antd';
import styles from './index.module.scss';
import { useProductKinds } from '@/stores';
import useUrlState from '@ahooksjs/use-url-state';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { useMallParams } from '@/stores';
import { omit } from 'lodash';

interface QueryType {
  title?: string;
  price?: string;
  ips?: string;
  factory?: string;
}

const { Option } = Select;
const HeaderSearch: React.FC = () => {
  const { navProductKindList } = useProductKinds();
  const location = useLocation();
  const navigate = useNavigate();
  const urlParams = useParams();
  const { updateMallParams } = useMallParams();
  const [query] = useUrlState<QueryType>({});
  const [selectvalue, setSelectValue] = useState<number>();
  const handleSearch = (e: any) => {
    const inputVal = e!.target.value;
    const item = navProductKindList.find((item) => item.id === selectvalue);
    if (item) {
      const mallid = (item.ename || '').replace(/\s*/g, '');
      updateMallParams({
        title: inputVal,
      });
      if (
        location.pathname.indexOf('/mall') === -1 ||
        mallid !== urlParams.mallid
      ) {
        navigate(`/mall/${mallid}`);
      }
    }
  };
  useEffect(() => {
    if (navProductKindList && navProductKindList.length) {
      setSelectValue(navProductKindList[0]?.id);
    }
  }, [navProductKindList]);
  useEffect(() => {
    // 仅同步一次url的筛选参数
    updateMallParams(
      omit(
        {
          ...query,
          ip_id__in: query.ips,
          price__range: query.price,
          factory__in: query.factory,
        },
        ['ips', 'price', 'factory'],
      ),
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <Input.Group compact className={styles.search}>
      <Select
        className="hedaer-search-select"
        popupClassName="hedaer-search-select-wrap"
        suffixIcon={<span className="icon-caret"></span>}
        bordered={false}
        value={selectvalue}
        onChange={setSelectValue}
      >
        {navProductKindList.map((item) => (
          <Option
            key={item.id}
            value={item.id}
            className="hedaer-search-select-item"
          >
            {item.ename}
          </Option>
        ))}
      </Select>
      <Input
        defaultValue={query.title || ''}
        onPressEnter={handleSearch}
        placeholder="Search products..."
        enterKeyHint="search"
        bordered={false}
      />
    </Input.Group>
  );
};

export default memo(HeaderSearch);
